import React from 'react'
import { WebhookRequestDetailProps } from './type'
import IMRequestDetail from './IMRequestDetail'

const FeishuRequestDetail = ({ requestPayload }: WebhookRequestDetailProps) => {
  return <IMRequestDetail requestPayload={requestPayload} targetsKey="at" />
}

export default FeishuRequestDetail
